import { DateTime } from 'luxon'
import { VueCurrencypluginOptions } from '../plugins/vue-currency-input'
import { parse } from 'vue-currency-input'
import { Constants } from './constants'
import { Atta, CreditoImobiliario, IApiResponse, IPreAnaliseItemList } from '@/interfaces'
import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { AttaServices } from './attaServices'
import { CPFUtil } from '@/utils/CpfUtil'
import { CancelTokenSource } from 'axios'

/*
    Adicionado APIKey da atta para todas as solicitacoes feitas pelo isolve.
    Ficará assim até o método de autenticação ficar pronto
    As APIS de chamada neste serviço requer eu seu cabeçalho x-api-key que se encontra na tabela Parceiro coluna apikey
*/
const http = AttaHttpClientFactory.create(Constants.API.CreditoImobiliario.host, {
	common: {
		'X-Api-Key': Constants.API.CreditoImobiliario.key
	}
})

export const CreditoImobiliarioService = {
	/**
	 * Serviços e chamadas relacionadas ao simulador
	 *
	 */

	/**
	 * Atualiza a situação da pré-análise
	 * @param preanalysisid
	 * @param status
	 * @returns
	 */
	async updatePreAnalysisSituation(scoreId: number, status: any) {
		const { data } = await http.post(`/score/update-situacao/${scoreId}`, status)
		return data
	},

	async linkFormCreditClicked(scoreId: number) {
		const { data } = await http.post(`/preanalysis/${scoreId}/linkformcreditclicked`)
		return data
	},

	async archivePreAnalysis(preAnaliseId: number, reason: string, complement: string | null) {
		const request = {
			toArchive: true,
			preAnaliseId: preAnaliseId,
			reason: reason,
			reasonComplement: complement
		}
		const response = await http.patch(`/preanalysis/${preAnaliseId}/toarchive`, request)
		return response
	},

	async duplicatePreAnalysis(preAnalysisId: number) {
		try {
			const response = await http.post(`/preanalysis/${preAnalysisId}/recreate`)
			if (response.status == 200) return true
		} catch (e) {
			return false
		}
	},

	async addObservation(preAnalysisId: number, observation: string, userId: number) {
		const request = {
			preAnalysisId: preAnalysisId,
			observation: observation,
			userId: userId
		}
		try {
			const response = await http.post(`/preanalysis/${preAnalysisId}/observations`, request)
			if (response.status == 200) return true
		} catch (e) {
			console.error('Failed to add observations ', preAnalysisId, e)
			return false
		}
	},

	async getPreAnalysisObservations(preAnalysisId: number) {
		const { data } = await http.get(`/preanalysis/${preAnalysisId}/observations`)
		return data
	},

	async setGotInTouch(consultaScoreId: number) {
		let response = await http.post(`/preanalysis/${consultaScoreId}/got-in-touch`)
		if (response.status == 200) return true
		return false
	},

	simulador: {
		/**
		 * Retorna o status de uma simulação enviada
		 * @param {*} simulacaoId
		 */
		async getStatus({ simulacaoId }: { simulacaoId: number }) {
			var response = await http.get(`/simulador/status/${simulacaoId}`)
			if (response.status == 200) return await response.data
			return false
		},

		/**
		 * Envia uma simulação
		 * @param {*} simulacao
		 */
		async add(simulacao: any) {
			var requestCopy = JSON.parse(JSON.stringify(simulacao))

			if (typeof requestCopy.dataNascimentoTitular == 'string') {
				var value = requestCopy.dataNascimentoTitular
				requestCopy.dataNascimentoTitular = DateTime.fromFormat(value, 'dd/MM/yyyy').set({ hour: 12 }).toJSON()
			}

			if (typeof requestCopy.dataNascimentoConjuge == 'string') {
				var value = requestCopy.dataNascimentoConjuge
				requestCopy.dataNascimentoConjuge = DateTime.fromFormat(value, 'dd/MM/yyyy').set({ hour: 12 }).toJSON()
			}

			if (typeof requestCopy.cpfTitular == 'string') {
				requestCopy.cpfTitular = parseInt(requestCopy.cpfTitular.replace(/\D/g, ''))
			}

			if (typeof requestCopy.cpfConjuge == 'string') {
				requestCopy.cpfConjuge = parseInt(requestCopy.cpfConjuge.replace(/\D/g, ''))
			}

			requestCopy.valorImovel = parse(requestCopy.valorImovel, VueCurrencypluginOptions.globalOptions)
			requestCopy.valorFinanciamento = parse(requestCopy.valorFinanciamento, VueCurrencypluginOptions.globalOptions)
			requestCopy.valorEntrada = requestCopy.valorImovel - requestCopy.valorFinanciamento

			var response = await http.post('/simulador', requestCopy)
			return await response.data
		},

		async getDados({ simulacaoId }: { simulacaoId: number }) {
			var response = await http.get(`/simulador/${simulacaoId}/dados`)
			if (response.status == 200) return await response.data
			return false
		},

		async propostaPorProponente({ cpf }: { cpf: string }) {
			var response = await http.get(`/cliente/${cpf}/propostas/andamento`)
			if (response.status == 200) return await response.data
			return false
		}
	},
	/**
	 * Serviços e chamadas relacionadas a consulta de score
	 */
	score: {
		parceiros: {
			async getAll({ uid }: { uid: number }) {
				let response = await http.get<Atta.API.Response.IListaParceiros>('/score/parceiros', {
					params: { uid: uid }
				})
				return response.data.result
			}
		},

		/**
		 *
		 * @param {PreAnaliseRequest} params
		 */
		async add(PreAnaliseRequestModel: any) {
			var requestCopy = JSON.parse(JSON.stringify(PreAnaliseRequestModel))

			if (!requestCopy.compradorUm.casado)
				requestCopy.compradorUm.conjuge = {
					cpf: null
				}

			if (!requestCopy.compradorDois.casado)
				requestCopy.compradorDois.conjuge = {
					cpf: null
				}

			if (typeof requestCopy.compradorUm.dtNascimento === 'string') {
				//setar horas em 12, porque em algumas datas a api esta recebendo com 1 hora a mais ou a menos, assim evita mudar a data
				var value = DateTime.fromFormat(requestCopy.compradorUm.dtNascimento, 'dd/MM/yyyy').set({ hour: 12 })
				requestCopy.compradorUm.dtNascimento = value.toJSON()
			}

			if (typeof requestCopy.compradorDois.dtNascimento === 'string') {
				//setar horas em 12, porque em algumas datas a api esta recebendo com 1 hora a mais ou a menos, assim evita mudar a data
				var value = DateTime.fromFormat(requestCopy.compradorDois.dtNascimento, 'dd/MM/yyyy').set({ hour: 12 })
				requestCopy.compradorDois.dtNascimento = value.toJSON()
			}

			if (requestCopy.compradorUm.cpf != null) {
				requestCopy.compradorUm.cpf = parseInt(requestCopy.compradorUm.cpf.replace(/\D/g, ''))
			}

			if (requestCopy.compradorDois.cpf != null) {
				requestCopy.compradorDois.cpf = parseInt(requestCopy.compradorDois.cpf.replace(/\D/g, ''))
			}

			if (requestCopy.compradorUm.conjuge && requestCopy.compradorUm.conjuge.cpf != null) {
				requestCopy.compradorUm.conjuge.cpf = parseInt(requestCopy.compradorUm.conjuge.cpf.replace(/\D/g, ''))
			}

			if (requestCopy.compradorDois.conjuge && requestCopy.compradorDois.conjuge.cpf != null) {
				requestCopy.compradorDois.conjuge.cpf = parseInt(requestCopy.compradorDois.conjuge.cpf.replace(/\D/g, ''))
			}

			if (requestCopy.compradorUm.conjuge && typeof requestCopy.compradorUm.conjuge.dtNascimento === 'string') {
				//setar horas em 12, porque em algumas datas a api esta recebendo com 1 hora a mais ou a menos, assim evita mudar a data
				var value = DateTime.fromFormat(requestCopy.compradorUm.conjuge.dtNascimento, 'dd/MM/yyyy').set({ hour: 12 })
				requestCopy.compradorUm.conjuge.dtNascimento = value.toJSON()
			}

			if (requestCopy.compradorDois.conjuge && typeof requestCopy.compradorDois.conjuge.dtNascimento === 'string') {
				//setar horas em 12, porque em algumas datas a api esta recebendo com 1 hora a mais ou a menos, assim evita mudar a data
				var value = DateTime.fromFormat(requestCopy.compradorDois.conjuge.dtNascimento, 'dd/MM/yyyy').set({ hour: 12 })
				requestCopy.compradorDois.conjuge.dtNascimento = value.toJSON()
			}

			if (requestCopy.simulacao.valorImovel != null) {
				requestCopy.simulacao.valorImovel = parse(requestCopy.simulacao.valorImovel, VueCurrencypluginOptions.globalOptions)
				requestCopy.simulacao.valorFinanciamento = parse(requestCopy.simulacao.valorFinanciamento, VueCurrencypluginOptions.globalOptions)
				requestCopy.simulacao.valorEntrada = requestCopy.simulacao.valorImovel - requestCopy.simulacao.valorFinanciamento
			} else {
				requestCopy.simulacao = null
			}

			//Somente bradesco aceita terreno, mas precisa ter o itau para poder fazer o score
			if (requestCopy.tipoImovel == Constants.TIPO_IMOVEL.TERRENO && !requestCopy.bancos.find((u: number) => u == Constants.BANCOS.ITAU))
				requestCopy.bancos.push(Constants.BANCOS.ITAU)

			const response = await http.post('/score', requestCopy)
			if (!response) {
				console.error(response)
			}
			return response.data
		},

		async getScores(id: number): Promise<Array<CreditoImobiliario.IScoreItemResponse>> {
			const response = await http.get(`/score/${id}`)
			if (!response) {
				return []
			}
			return response.data.result
		},

		async getConsultas(params: any, cancelationToken: CancelTokenSource | null = null) {
			let response = await http.get<IApiResponse<Array<IPreAnaliseItemList>>>('/score/consultas', {
				params,
				cancelToken: cancelationToken?.token
			})
			return response.data
		},

		async getDados({ scoreId }: { scoreId: number }) {
			var response = await http.get(`/score/${scoreId}/dados`)

			if (response.status == 200) return await response.data

			return false
		},

		async getDetalhesPreAnalise({ scoreId, fornecedorId }: { scoreId: number; fornecedorId: number | null }) {
			let url: string = `/score/${scoreId}/detalhes`

			if (fornecedorId) url = `/score/${scoreId}/detalhes/${fornecedorId}`

			var response = await http.get(url)
			if (response.status == 200) return response.data.result

			return false
		},

		async salvarPreAnaliseDetalhes({
			scoreId,
			detalhesPreAnalise,
			fornecedorId
		}: {
			scoreId: number
			detalhesPreAnalise: CreditoImobiliario.IPreAnaliseModel
			fornecedorId: number | null
		}) {
			let requestCopy: CreditoImobiliario.PreAnaliseModel = JSON.parse(JSON.stringify(detalhesPreAnalise))

			requestCopy.proponentes = detalhesPreAnalise.proponentes.filter((element) => element.isConjuge != true)
			requestCopy.proponentes = JSON.parse(JSON.stringify(requestCopy.proponentes))
			//Arrumar dados bancarios dos clientes
			//no front esta como array, mas no back esta como campo individual (campo1, campo2, campo3,...)
			let auxiliarConversaoData: string = ''
			requestCopy.proponentes.map((element) => {
				if (element.cpf) element.cpf = parseFloat(element.cpf.toString().replace(/\D/g, ''))

				if (element.nrCep) element.nrCep = element.nrCep.toString().replace('-', '')

				if (element.nrCnpjSocioProprietario) element.nrCnpjSocioProprietario = CPFUtil.cleanCnpj(element.nrCnpjSocioProprietario.toString())

				if (element.dtNascimento) element.dtNascimento = ArrumarDataJson(element.dtNascimento)

				if (element.dtAdmissao) element.dtAdmissao = ArrumarDataJson(element.dtAdmissao)

				if (element.dtEmissaoRg) element.dtEmissaoRg = ArrumarDataJson(element.dtEmissaoRg)

				if (element.dtCasamentoUniaoEstavel) element.dtCasamentoUniaoEstavel = ArrumarDataJson(element.dtCasamentoUniaoEstavel)

				if (element.dataEmissaoDocto) element.dataEmissaoDocto = ArrumarDataJson(element.dataEmissaoDocto)

				if (element.dsOrgaoExpedidorRg && element.dsOrgaoExpedidorRg.includes('undefined')) element.dsOrgaoExpedidorRg = ''

				//Se tiver conjuge, arrumar os dados
				if (element.conjuge) {
					if (element.conjuge.cpf) element.conjuge.cpf = parseFloat(element.conjuge.cpf.toString().replace(/\D/g, ''))

					if (element.conjuge.nrCnpjSocioProprietario)
						element.conjuge.nrCnpjSocioProprietario = CPFUtil.cleanCnpj(element.conjuge.nrCnpjSocioProprietario.toString())

					if (element.conjuge.nrCep) element.conjuge.nrCep = element.conjuge.nrCep.toString().replace('-', '')

					if (element.conjuge.dtNascimento) element.conjuge.dtNascimento = ArrumarDataJson(element.conjuge.dtNascimento)

					if (element.conjuge.dtAdmissao) element.conjuge.dtAdmissao = ArrumarDataJson(element.conjuge.dtAdmissao)

					if (element.conjuge.dtEmissaoRg) element.conjuge.dtEmissaoRg = ArrumarDataJson(element.conjuge.dtEmissaoRg)

					if (element.conjuge.dtCasamentoUniaoEstavel)
						element.conjuge.dtCasamentoUniaoEstavel = ArrumarDataJson(element.conjuge.dtCasamentoUniaoEstavel)

					if (element.conjuge.dataEmissaoDocto) element.conjuge.dataEmissaoDocto = ArrumarDataJson(element.conjuge.dataEmissaoDocto)

					if (element.conjuge.dsOrgaoExpedidorRg && element.conjuge.dsOrgaoExpedidorRg.includes('undefined'))
						element.conjuge.dsOrgaoExpedidorRg = ''
				}
			})

			if (!requestCopy.dadosOperacao.valorFGTS) requestCopy.dadosOperacao.valorFGTS = 0

			let url: string = `/score/${scoreId}/detalhes/atualizar`

			if (fornecedorId) url = `/score/${scoreId}/detalhes/atualizar/${fornecedorId}`

			const response = await http.post(url, requestCopy)
			if (response.status == 200) {
				//TODO: Melhorar os processos desse serviço e separar as responsabilidades
				//Upload dos documentos
				for (let i = 0; i < detalhesPreAnalise.proponentes.length; i++) {
					try {
						//Verifico se tem o proponente com cpf
						if (detalhesPreAnalise.proponentes[i] && detalhesPreAnalise.proponentes[i].cpf) {
							let proponente = detalhesPreAnalise.proponentes[i]
							//Verifico se tem documentos para fazer o upload
							if (proponente.documentosList && proponente.documentosList.length > 0) {
								for (let indexDocumento = 0; indexDocumento < proponente.documentosList.length; indexDocumento++) {
									if (!proponente.documentosList[indexDocumento].uploaded) {
										await AttaServices.postDocumentoUpload(
											proponente.documentosList[indexDocumento].file,
											CPFUtil.clean(proponente.cpf.toString()),
											proponente.documentosList[indexDocumento].topic,
											proponente.documentosList[indexDocumento].type,
											scoreId
										)
										proponente.documentosList[indexDocumento].uploaded = true
									}
								}
							}
							//Se tiver conjuge com cpf, fazer o upload dele tambem
							if (detalhesPreAnalise.proponentes[i].conjuge && detalhesPreAnalise.proponentes[i].conjuge?.cpf) {
								let conjuge = detalhesPreAnalise.proponentes[i].conjuge
								//Verifico se tem documentos para fazer o upload
								if (conjuge!.documentosList && conjuge!.documentosList.length > 0) {
									for (let indexDocumento = 0; indexDocumento < conjuge!.documentosList.length; indexDocumento++) {
										if (!conjuge!.documentosList[indexDocumento].uploaded) {
											await AttaServices.postDocumentoUpload(
												conjuge!.documentosList[indexDocumento].file,
												CPFUtil.clean(conjuge!.cpf.toString()),
												conjuge!.documentosList[indexDocumento].topic,
												conjuge!.documentosList[indexDocumento].type,
												scoreId
											)
											conjuge!.documentosList[indexDocumento].uploaded = true
										}
									}
								}
							}
						}
					} catch (error) {
						console.log('Erro ao fazer o upload dos documentos: ', error)
					}
				}
				return await response.data.result
			}

			return false
		}
	},

	proposta: {
		async gerarPropostas({
			scoreId,
			bancoSubProduto
		}: {
			scoreId: number
			bancoSubProduto: Array<CreditoImobiliario.GerarPropostaSubProduto>
		}) {
			let request = {
				consultaScoreId: scoreId,
				bancoSubProduto: bancoSubProduto
			}

			let response = await http.post(`/proposta/${scoreId}/gerar`, request)

			if (response.status == 200) return await response.data.result

			return false
		},

		async reenviarParaBanco({ propostaItauId }: { propostaItauId: number }) {
			let request = {
				propostaItauId: propostaItauId
			}

			let response = await http.post(`/proposta/${propostaItauId}/enviar-para-banco`, request)

			if (response.status == 200) return await response.data.result

			return false
		}
	}
}

/**
 * Arruma data para o envio em json
 */
//TODO: Talvez deixar esse metodo global
function ArrumarDataJson(data: string) {
	let auxiliarConversaoData = ''
	auxiliarConversaoData = DateTime.fromFormat(data, 'dd/MM/yyyy').set({ hour: 12 }).toJSON()

	if (auxiliarConversaoData) return auxiliarConversaoData
	return data
}
